import { render } from "./TeamSelection.vue?vue&type=template&id=0c02e47f"
import script from "./TeamSelection.vue?vue&type=script&lang=js"
export * from "./TeamSelection.vue?vue&type=script&lang=js"

import "./TeamSelection.vue?vue&type=style&index=0&id=0c02e47f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__